import React from "react";
import { LegalLayout, Section } from "@/components/LegalLayout";

const G = ({ title, children }) => (
  <div className="rounded-2xl border border-zinc-200 bg-white p-5">
    <h3 className="font-display font-bold text-zinc-900">{title}</h3>
    <div className="mt-1.5 text-sm text-zinc-600">{children}</div>
  </div>
);

export default function BusinessGuidelines() {
  return (
    <LegalLayout
      metaTitle="Business Guidelines — Nearfluence"
      metaDescription="How businesses should use Nearfluence: genuine opportunities, accurate compensation, clear deliverables, timely payments, professional conduct and legal responsibilities."
      title="Business Guidelines"
      subtitle="What we ask of businesses to keep opportunities genuine and fair for creators."
    >
      <Section>
        <div className="grid gap-4 sm:grid-cols-2">
          <G title="Genuine opportunities">Only publish genuine opportunities that you are authorised to offer.</G>
          <G title="Accurate compensation">
            Clearly describe what creators will receive, including:
            <ul className="mt-2 list-disc pl-5">
              <li>Cash payment</li><li>Gifted products</li><li>Complimentary services</li><li>Experiences</li><li>Any combination of these</li>
            </ul>
          </G>
          <G title="Deliverables">Clearly explain what you expect from creators before a collaboration is agreed.</G>
          <G title="Payments">Where a paid collaboration is agreed, you remain responsible for making the agreed payment according to the terms agreed with the creator, unless Nearfluence explicitly provides a payment service for that transaction.</G>
          <G title="Professional conduct">Communicate respectfully. Do not use Nearfluence to send spam, discriminatory requests, misleading offers or inappropriate content.</G>
          <G title="Legal responsibilities">You are responsible for ensuring campaigns comply with applicable advertising, consumer protection and other relevant laws and regulations.</G>
        </div>
      </Section>
    </LegalLayout>
  );
}
